// extracted by mini-css-extract-plugin
export var tabsIndicator = "styles-module__tabsIndicator___Sb0s8";
export var tabsScrollButtons = "styles-module__tabsScrollButtons___R_59R";
export var tabsRoot = "styles-module__tabsRoot___ZjeW5";
export var tabsScroller = "styles-module__tabsScroller___osp8c";
export var flexContainer = "styles-module__flexContainer___Rct4D";
export var tabRoot = "styles-module__tabRoot___tvzTy";
export var ssrFallback = "styles-module__ssrFallback___TSqgk";
export var ssrTab = "styles-module__ssrTab___HZCY9";
export var activeSsrTab = "styles-module__activeSsrTab___kFT6E";
export var tabWrapper = "styles-module__tabWrapper___QY_wC";
export var selectedTabWrapper = "styles-module__selectedTabWrapper___Rpj4b";
export var textColorInherit = "styles-module__textColorInherit___z6Zur";